<template>
  <v-container>
    <taxCommentList />
  </v-container>
</template>

<script>
import taxCommentList from '../../components/shared/taxComments/taxCommentList.vue';

export default {
  name: 'TaxCommentTypes',
  components: {
    taxCommentList,
  },
};
</script>
